import React, { useEffect, useState} from "react";
import Calendar from "../../components/Calendar/Calendar";
import { formateDate } from "../../utils/utils"
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
const DateTimeRange = ({
  searchDocument,

}) => {
  const [showByDateRangeFrom, setDateRangeFrom] = useState(false);
  const [showByDateRangeTo, setDateRangeTo] = useState(false);
  const [startTimestamp, setStartTimeStamp] = useState('');
  const [endTimestamp, setEndTimestamp] = useState('');
  // const [startTime, setStartTime]= useState();
  // const [endTime, setEndTime]= useState();
  const[fromTime, setFromTime]=useState({
    startHour:"",
    startMin:"",
    startSec:""
  });
  const[endTime, setEndTime]=useState({
    endHour:"",
    endMin:"",
    endSec:""
  });
  
  

const rangeDateMax=(startTimestamp)=>{
  const currentDate= new Date();
  currentDate.setHours(0,0,0,0);
  let date=new Date(startTimestamp);
 
  
  date.setDate(date.getDate() + 6);
  date= new Date(date);
  date.setHours(0,0,0,0);

  if(date.setHours(0,0,0,0)>currentDate.setHours(0,0,0,0)){
    return currentDate
  }else{
    return date 
  }

   
}
const rangeDateMin=(endTimestamp)=>{
  let date;
  date= new Date(endTimestamp);
  date.setDate(date.getDate() - 6);
  return date   
}

const changeHandlerFromTime=(value, name)=>{
  const letters= /^[0-9]*$/
    if(name==='startHour'){ 
      if( (letters.test(value) || value==="")&& ( value<24)){
        setFromTime({
          ...fromTime,
          [name]: value
      });
         }
       
  }
  else if(name==="startMin"){
    if( (letters.test(value) || value==="")&& ( value<=59)){
      setFromTime({
        ...fromTime,
        [name]: value
    });
  }
  }else if(name==="startSec"){
    if( (letters.test(value) || value==="")&& ( value<=59)){
      setFromTime({
        ...fromTime,
        [name]: value
    });
  }
  }
 
     }

     const changeHandlerToTime=(value, name)=>{
      const letters= /^[0-9]*$/
        if(name==='endHour'){ 
          if( (letters.test(value) || value==="")&& ( value<24)){
            setEndTime({
              ...endTime,
              [name]: value
          });
             }
           
      }
      else if(name==="endMin"){
        if( (letters.test(value) || value==="")&& ( value<=59)){
          setEndTime({
            ...endTime,
            [name]: value
        });
      }
      }else if(name==="endSec"){
        if( (letters.test(value) || value==="")&& ( value<=59)){
          setEndTime({
            ...endTime,
            [name]: value
        });
      }
      }
    }
     const fromButtonHandler=(e)=>{
        e.preventDefault();
        setFromTime({
          startHour:"",
          startMin:"",
          startSec:""
        })
       
     }
     const endButtonHandler=(e)=>{
      e.preventDefault();
      setEndTime({
        endHour:"",
        endMin:"",
        endSec:""
      })
     }
     
     
  const checkZeroForFromTime=(value,name)=>{
    if(value.length === 1){
      setFromTime({
        ...fromTime,
        [name]:"0"+[value],
    });
  }
}
const checkZeroForToTime=(value,name)=>{
  if(value.length === 1){
    setEndTime({
      ...endTime,
      [name]:"0"+[value],
  });
}
}

  const isSearchEnabled =
    startTimestamp &&
    endTimestamp &&
    fromTime.startHour &&
    fromTime.startMin &&
    fromTime.startSec &&
    endTime.endHour &&
    endTime.endMin &&
    endTime.endSec;

  const renderTimeFields = (
    timeValues,
    changeHandler,
    checkZeroHandler,
    clearHandler
  ) => (
    <div className="document-datetime-range__time-input">
      <input
        className="input-time"
        maxLength={2}
        placeholder="HH"
        name={Object.keys(timeValues)[0]}
        value={timeValues[Object.keys(timeValues)[0]]}
        onChange={(e) => changeHandler(e.target.value, e.target.name)}
        onBlur={(e) => checkZeroHandler(e.target.value, e.target.name)}
      />
      <span className="collon-space">:</span>
      <input
        className="input-time"
        placeholder="MM"
        maxLength={2}
        name={Object.keys(timeValues)[1]}
        value={timeValues[Object.keys(timeValues)[1]]}
        onChange={(e) => changeHandler(e.target.value, e.target.name)}
        onBlur={(e) => checkZeroHandler(e.target.value, e.target.name)}
      />
      <span className="collon-space">:</span>
      <input
        className="input-time"
        placeholder="SS"
        maxLength={2}
        name={Object.keys(timeValues)[2]}
        value={timeValues[Object.keys(timeValues)[2]]}
        onChange={(e) => changeHandler(e.target.value, e.target.name)}
        onBlur={(e) => checkZeroHandler(e.target.value, e.target.name)}
      />
      <button
        type="button"
        className="cross-btn"
        onClick={clearHandler}
        aria-label="Clear time"
      >
        &#x2716;
      </button>
    </div>
  );

  return (
    <div className="duration-sec-wrapper document-datetime-range">
      <div
        className={`dateRangeSec document-datetime-range__panel ${
          startTimestamp && endTimestamp ? "selected" : ""
        }`}
      >
        <label className="date-range-text">
          Date Time Range<span style={{ color: "red" }}>*</span>
        </label>

        <div className="document-datetime-range__row">
          <div className="date-input-row">
            <label htmlFor="document-from-date">From</label>
            <div
              id="document-from-date"
              role="button"
              tabIndex={0}
              className="input-box"
              onClick={() => {
                setDateRangeFrom(true);
                setDateRangeTo(false);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  setDateRangeFrom(true);
                  setDateRangeTo(false);
                }
              }}
            >
              <span
                className={`date-value ${startTimestamp ? "active" : ""}`}
              >
                {startTimestamp
                  ? formateDate(new Date(startTimestamp))
                  : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon"></span>
            </div>
          </div>

          <div className="document-datetime-range__time-field">
            <label className="document-datetime-range__time-label" htmlFor="document-from-time">
              From Time
            </label>
            <div id="document-from-time">
              {renderTimeFields(
                fromTime,
                changeHandlerFromTime,
                checkZeroForFromTime,
                fromButtonHandler
              )}
            </div>
          </div>
        </div>

        <div className="document-datetime-range__row">
          <div className="date-input-row">
            <label htmlFor="document-to-date">To</label>
            <div
              id="document-to-date"
              role="button"
              tabIndex={0}
              className="input-box"
              onClick={() => {
                setDateRangeTo(true);
                setDateRangeFrom(false);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  setDateRangeTo(true);
                  setDateRangeFrom(false);
                }
              }}
            >
              <span className={`date-value ${endTimestamp ? "active" : ""}`}>
                {endTimestamp
                  ? formateDate(new Date(endTimestamp))
                  : "DD/MM/YYYY"}
              </span>
              <span className="calendar_icon"></span>
            </div>
          </div>

          <div className="document-datetime-range__time-field">
            <label className="document-datetime-range__time-label" htmlFor="document-to-time">
              To Time
            </label>
            <div id="document-to-time">
              {renderTimeFields(
                endTime,
                changeHandlerToTime,
                checkZeroForToTime,
                endButtonHandler
              )}
            </div>
          </div>
        </div>

        <div className="document-datetime-range__actions">
          <button
            type="button"
            className={
              isSearchEnabled
                ? "document-datetime-range__btn document-datetime-range__btn--primary"
                : "document-datetime-range__btn document-datetime-range__btn--disabled"
            }
            disabled={!isSearchEnabled}
            onClick={() => {
              searchDocument(
                new Date(startTimestamp),
                new Date(endTimestamp),
                fromTime,
                endTime
              );
            }}
          >
            Search
          </button>
        </div>
      </div>
    {showByDateRangeFrom && (
      <MobilePopUp
        hideCloseBtn={true}
        removeHeader={true}
        cssClass="daterange-mobilepopup"
      >
        <Calendar
          dob={startTimestamp}
          minDate={endTimestamp ?rangeDateMin(endTimestamp):""}
          maxDate={endTimestamp ?endTimestamp :new Date()}
          // minDate={minDate}
          // maxDate={endTimestamp ?endTimestamp :new Date()}
          onCancel={() => {
            setDateRangeFrom(false);
            //showSelectedMobilePopUp(true);
            setStartTimeStamp("");
          }}
          onApply={(sd) => {
            setDateRangeFrom(false);
            //showSelectedMobilePopUp(true);
            setStartTimeStamp( sd);
          }}
        />
      </MobilePopUp>
    )}
    {showByDateRangeTo && (
      <MobilePopUp
        hideCloseBtn={true}
        removeHeader={true}
        cssClass="daterange-mobilepopup"
      >
        <Calendar
          dob={endTimestamp}
          minDate={startTimestamp?startTimestamp :""}
          maxDate={startTimestamp?rangeDateMax(startTimestamp) :new Date()}
          prevFieldDate={startTimestamp?rangeDateMax(startTimestamp) :new Date()}
          // minDate={startTimestamp?startTimestamp :minDate}
          // maxDate={new Date()}
          onCancel={() => {
            setDateRangeTo(false);
           // showSelectedMobilePopUp(true);
           setEndTimestamp("");
          }}
          onApply={(sd) => {
            setDateRangeTo(false);
            //showSelectedMobilePopUp(true);
            setEndTimestamp(sd);
          }}
        />
      </MobilePopUp>
    )}</div>);
};
 
export default DateTimeRange;
